import tw from 'twin.macro';
import styled from 'styled-components';

export const FooterWrapper = tw.div`
  mx-auto max-w-7xl px-6 lg:px-4 py-10 sm:py-10
`;

export const Heading = tw.h2`
  text-4xl mt-10 tracking-tight mb-5
`;

export const ContactGrid = tw.dl`
  grid grid-cols-1 gap-x-8 gap-y-16 lg:grid-cols-3
`;

export const ContactItem = tw.div`
  flex mt-3
`;

export const Icon = tw.div`
  text-5xl text-gray-700
`;

export const TextContainer = tw.div`
  ms-3
`;

export const Title = tw.dt`
  text-lg uppercase text-black
`;

export const Description = tw.dd`
  text-base font-normal uppercase
`;

export const NewsletterLabel = tw.label`
  text-lg uppercase text-black font-semibold mt-3
`;

export const EmailInput = tw.input`
  border-b border-black w-64 p-2 mt-2
`;

export const SubscribeButton = tw.button`
  border border-black py-2 px-3 mt-3 uppercase font-semibold transition duration-300 ease-in-out hover:bg-gray-900 hover:text-white
`;

export const FooterBottom = tw.div`
  flex mt-10 items-start
`;

export const FooterLogo = tw.img`
  w-56
`;

export const DisclaimerText = tw.p`
  text-lg ml-auto sm:ml-6 mt-8 space-y-4 text-left font-medium
`;

export const CopyrightSection = tw.div`
  flex mt-10 items-center justify-between w-full
`;

export const CopyrightText = tw.p`
  text-lg font-medium
`;

export const PoweredByText = tw.p`
  text-lg font-medium
`;

export const SocialMediaContainer = tw.div`
  flex gap-2 text-2xl font-medium
`;

export const SocialMediaLink = styled.a`
  ${tw`h-10 w-10 border border-black bg-gray-900 text-white rounded-full flex items-center justify-center`}
  &:hover {
    ${tw`bg-white text-black`}
  }
`;
